/* global axios */
import ApiClient from './ApiClient';

class ProspectingListsAPI extends ApiClient {
  constructor() {
    super('prospecting_lists', { accountScoped: true });
  }

  showPage(id, page, perPage) {
    return axios.get(`${this.url}/${id}`, {
      params: { page, per_page: perPage },
    });
  }

  estimate(payload) {
    return axios.post(`${this.url}/estimate`, payload);
  }

  // Prospecção INTERNACIONAL (país != BR) via Apollo. Monta a lista em background.
  internationalSearch(payload) {
    return axios.post(`${this.url}/international_search`, payload);
  }

  // recordIds vazio = lista inteira; preenchido = só as empresas escolhidas na tela.
  enrichDecisors(id, recordIds = []) {
    return axios.post(`${this.url}/${id}/enrich_decisors`, {
      record_ids: recordIds,
    });
  }

  // Acha o Instagram das empresas da lista (busca web, grátis). Vazio = lista inteira.
  findInstagram(id, recordIds = []) {
    return axios.post(`${this.url}/${id}/find_instagram`, {
      record_ids: recordIds,
    });
  }

  // Internacional (Apollo): revela o WhatsApp do decisor sob demanda (R$2 cada).
  enrichPhones(id, recordIds = []) {
    return axios.post(`${this.url}/${id}/enrich_phones`, {
      record_ids: recordIds,
    });
  }

  // Refaz a mesma busca internacional (lista vazia ou pedido incompleto).
  rebuild(id) {
    return axios.post(`${this.url}/${id}/rebuild`);
  }

  // Cria uma campanha de e-mail a partir da prospecção (template + caixa de e-mail).
  createEmailCampaign(id, payload) {
    return axios.post(`${this.url}/${id}/create_email_campaign`, payload);
  }

  // Excluir de vez: apaga a prospecção da base (mantém os Contacts já comprados).
  purge(id) {
    return axios.delete(`${this.url}/${id}/purge`);
  }

  archive(id, label = null) {
    const query = label ? `?label=${encodeURIComponent(label)}` : '';
    return axios.delete(`${this.url}/${id}${query}`);
  }

  segments() {
    return axios.get(`${this.url}/segments`);
  }

  // Planilha do Google (fonte viva): lê cabeçalhos + amostra antes de conectar.
  sheetPreview(payload) {
    return axios.post(`${this.url}/sheet_preview`, payload);
  }

  // Prospecção Do CRM: quantos contatos a etiqueta/etapa traz hoje + nome sugerido.
  crmPreview(payload) {
    return axios.post(`${this.url}/crm_preview`, payload);
  }

  // "Sincronizar agora" numa prospecção de planilha ou Do CRM.
  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }

  portes() {
    return axios.get(`${this.url}/portes`);
  }
}

export default new ProspectingListsAPI();
